module.exports = __webpack_public_path__ + "files/418b7c065bf85a77d0fe7b7649ba7ffe.svg";